import React, { useEffect, useState } from 'react'
import { adminLoginApi } from '../../../api/admin/auth'
import { useAdminStore } from '../../../store/userStore'
import { adminLoginSchema } from '../../../utils/validation/admin/yup/auth/adminLoginYup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useLocation, useNavigate } from 'react-router-dom'
import { removeLocalStorage, saveLocalStorage } from '../../../utils/localStorage/localStorage'
import { swalErrorAlert } from '../../../utils/swal/swal'
import { useSocketStore } from '../../../store/socketStore'

const AdminLogin = () => {

  // 관리자 css, js 로드
  useEffect(() => {
    const link = document.createElement("link")
    link.rel = "stylesheet"
    link.href = "/styles/sb-admin.css"
    document.head.appendChild(link)

    const scriptTag = document.createElement("script")
    scriptTag.src = "/js/sb-admin.js"
    document.head.appendChild(scriptTag)

    return () => {
      document.head.removeChild(link)
      document.head.removeChild(scriptTag)
    }
  }, []);

  /* zustand */
  const { adminInfo, adminLoginAction } = useAdminStore(state => state)
  const { connectSocket } = useSocketStore(state => state)


  /* useState */
  const [checkboxSaveId, setCheckboxSaveId] = useState(localStorage.getItem('saveAdminId') ? true : false)

  /* navigation & location */
  const navigate = useNavigate();
  const location = useLocation();

  /* Validation - Yup & React-hook-form */
  const schema = adminLoginSchema
  const { register, handleSubmit, setError, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: localStorage.getItem('saveAdminId') ? localStorage.getItem('saveAdminId') : ''
    },
  })

  /* UseEffect */
  useEffect(()=>{
    if(adminInfo) navigate('/hy-admin')

  },[adminInfo])

  /* Methods */
  const onSubmitLogin = async (data) => {
    // 아이디 저장
    checkboxSaveId ? saveLocalStorage('saveAdminId', data.email) : removeLocalStorage('saveAdminId')

    // API 요청
    try {
      const requestData = data
      const response = await adminLoginApi(requestData)

      let userInfo = response?.data?.resData?.userInfo
      connectSocket(userInfo.user_id); // 소켓연결
      adminLoginAction(userInfo)

      const from = (location?.state?.from?.pathname && location?.state?.from?.pathname.indexOf('/hy-admin') !== false)
        ? location?.state?.from?.pathname
        : '/hy-admin'
      navigate(from)

      return

    } catch (error) {
      if (error.status === 400) {
        setError('loginFail', {
          type: 'manual', // 오류를 수동으로 설정
          message: '아이디 또는 비밀번호가 잘못 되었습니다', // DB에서 받아온 에러 메시지
        })
        return
      } else {
        swalErrorAlert('로그인 실패', '로그인 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.', 'error', '확인')
        return
      }
    }
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-6 d-none d-lg-block bg-login-image" />
                  <div className="col-lg-6">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">로그인</h1>
                      </div>

                      {/* Form */}
                      <form className="user" onSubmit={handleSubmit(onSubmitLogin)}>
                        <div className="form-group">
                          <input type="text"
                            name="email"
                            id="exampleInputEmail"
                            className={errors.email ? "form-control form-control-user border-danger" : "form-control form-control-user"}
                            aria-describedby="emailHelp"
                            placeholder="아이디"
                            {...register('email')}
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            name="password"
                            id="exampleInputPassword"
                            className={errors.password ? "form-control form-control-user border-danger" : "form-control form-control-user"}
                            placeholder="비밀번호"
                            {...register('password')}
                          />
                        </div>

                        {/* Error Msg */}
                        <div className='form-group text-center'>
                          {(errors.email || errors.password || errors.loginFail) && <p className='small text-danger'>아이디 또는 비밀번호가 잘못 되었습니다</p>}
                        </div>

                        {/* Save ID */}
                        <div className="form-group">
                          <div className="custom-control custom-checkbox small">
                            <input
                              type="checkbox" className="custom-control-input" id="checkboxSaveId" name='checkboxSaveId'
                              checked={checkboxSaveId} onChange={e => setCheckboxSaveId(e.target.checked)}
                            />
                            <label className="custom-control-label" htmlFor="checkboxSaveId">아이디저장</label>
                          </div>
                        </div>

                        <button type='submit' className='btn btn-primary btn-user btn-block'>로그인</button>
                      </form>
                      <hr />
                      {/* <div className="text-center">
                        <Link to={"#"} className="small">비밀번호 찾기</Link>
                        <Link to={"#"} className="small">회원가입</Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminLogin